export const options = {
  defaultWidth: 50,
  defaultHeight: 22,
  tableStyle: {
    borderSpacing: 0,
    Layout: 'fixed',
    wordBreak: 'break-word',
  }
};
